import { v4 as uuidv4 } from 'uuid';

import type { CreativeWithRefInput } from '../../../../../../../../apis/graphql/types';
import { CreativeV5Type } from '../../../../../../../../apis/graphql/types';
import { isRecognizedConfig } from '../../../../../../../../configs';
import type { TagSheetAd } from '../../../../types';
import { isSupportedCreativeType } from '../../../../utils/creative';

export const convertTagSheetAdToCreativeInput = (
  tagSheetAd: TagSheetAd,
  creativeLibraryId: string
): CreativeWithRefInput | null => {
  const { creative } = tagSheetAd;
  const { creativeType, creativeName, creativeUrl } = creative;

  if (!isRecognizedConfig(creativeType) || !isSupportedCreativeType(creativeType.key)) return null;

  const ref = uuidv4();

  switch (creativeType.key) {
    case CreativeV5Type.VastVideo:
      return {
        ref,
        creative: {
          vastVideoCreative: {
            name: creativeName,
            type: CreativeV5Type.VastVideo,
            url: creativeUrl ?? '',
            vpaid: false,
            creativeLibraryId,
          },
        },
      };
    case CreativeV5Type.Video:
      return {
        ref,
        creative: {
          videoCreative: {
            name: creativeName,
            type: CreativeV5Type.Video,
            creativeLibraryId,
          },
        },
      };
    case CreativeV5Type.Slate:
      return {
        ref,
        creative: {
          slateCreative: {
            name: creativeName,
            type: CreativeV5Type.Slate,
            creativeLibraryId,
          },
        },
      };
    default:
      return null;
  }
};
